import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EditIcon from '@mui/icons-material/Edit';
import HomeIcon from '@mui/icons-material/Home';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Button, Container, IconButton, Tooltip, Typography } from '@mui/material';
import { useEffect, useReducer, useState } from 'react';
import { Link } from "react-router-dom";
import { AppBarStyle } from '../../../customStyles';

const shortCutsStateReducer = (state: any, action: any): any => {
    switch (action.type) {
        case 'TOGGLE_SHORTCUT_VISIBILITY':
            return {
                ...state,
                shortcuts: state.shortcuts.map((shortcut) => {

                    if (shortcut.id === action.payload) {
                        return {
                            ...shortcut,
                            isVisible: !shortcut.isVisible
                        }
                    }
                    return shortcut
                }
                )
            }
        case 'MARK_SHORTCUT_FOR_VISIBILITY_CHANGE':
            return {
                ...state,
                shortcutsToSave: state.shortcutsToSave.includes(action.payload)
                    ? state.shortcutsToSave.filter((id) => id !== action.payload)
                    : [...state.shortcutsToSave, action.payload]
            }
        default:
            return state
    }
}

const Shortcut: React.FC<any> = ({ children, label, description, isEditMode, toggleVisibility, shortcutId, dispatch, state }) => {
    const [isVisible, setIsVisible] = useState(state.shortcuts.find(shortcut => shortcut.id === shortcutId)?.isVisible || false);

    const handleVisibleClick = () => {
        setIsVisible(!isVisible)
        toggleVisibility(shortcutId)
    }
    const backgroundColor = isVisible ? 'var(--action-disabled-background, rgba(16, 17, 28, 0.12));' : null;
    const showShortCut = state.shortcuts.isVisible ? 'none' : 'flex'

    return (
        <Container maxWidth={false} disableGutters sx={{
            ...AppBarStyle.shortcutContainer,
            backgroundColor: backgroundColor,
            display: showShortCut
        }}>
            <Container sx={{ display: "flex", justifyContent: "flex-end" }} maxWidth={false} disableGutters>
                {isEditMode === true ?
                    <Tooltip title={isVisible ? "Hide" : "Show"}>
                        <IconButton sx={AppBarStyle.iconButton} onClick={handleVisibleClick} aria-label={isVisible ? 'Visibility off' : 'Visibility on'}>
                            {isVisible ?
                                <VisibilityOffIcon />
                                :
                                <VisibilityIcon />
                            }
                        </IconButton>
                    </Tooltip>
                    :
                    <IconButton sx={AppBarStyle.iconButton} disabled={true}>
                    </IconButton>
                }

            </Container>
            <Container disableGutters sx={AppBarStyle.typographyContainer}>
                {children}
                <Typography color="black" sx={AppBarStyle.shortcutTypography}>
                    {label}
                </Typography>
                <Typography color="grey" sx={AppBarStyle.shortcutTypography}>
                    {description}
                </Typography>
            </Container>
        </Container>
    )
}

const Shortcuts: React.FC = () => {
    const [isEditMode, setIsEditMode] = useState(false)
    const [state, dispatch] = useReducer(shortCutsStateReducer, {
        isEditMode: false,
        shortcuts: [
            {
                id: 1,
                isVisible: true,
                name: 'Dashboard',
                description: 'All Tasks',
                icon: <HomeIcon color="primary" />,
                link: 'transaction-summary'
            },
            {
                id: 2,
                isVisible: true,
                name: 'Transaction Summary',
                description: 'View Transactions',
                icon: <SwapHorizIcon color="primary" />,
                link: 'transaction-summary'
            },
            {
                id: 3,
                isVisible: true,
                name: 'Rapback Summary',
                description: 'View or Print Results',
                icon: <AccessTimeIcon color="primary" />,
                link: 'rapback-summary'
            },
            {
                id: 4,
                isVisible: true,
                name: 'Agency User Management',
                description: 'Settings',
                icon: <StarBorderIcon color="primary" />,
                link: 'agency-management'
            },
        ],
        shortcutsToSave: []
    })

    const toggleEdit = () => {
        setIsEditMode(!isEditMode)
    }

    const handleToggleShortCutVisbility = (shortcutId) => {
        dispatch({ type: 'MARK_SHORTCUT_FOR_VISIBILITY_CHANGE', payload: shortcutId })
    }

    const handleSaveChanges = () => {
        setIsEditMode(!isEditMode)
        state.shortcutsToSave.forEach((shortcutId) => {
            dispatch({ type: 'TOGGLE_SHORTCUT_VISIBILITY', payload: shortcutId })
        })
    }

    useEffect(() => {
    }, [handleToggleShortCutVisbility, handleSaveChanges])

    const handleReset = () => {

    }

    return (
        <>
            <Container disableGutters sx={{ alignItems: "center", marginTop: "5px", paddingTop: "6px", paddingBottom: "6px", paddingLeft: "16px", paddingRight: "16px", display: "flex", flexDirection: "row" }}>
                <Container disableGutters>
                    <Typography sx={{
                        fontFamily: "Montserrat",
                        fontWeight: "400",
                        fontSize: "20px",
                        lineHeight: "35px",
                        letterSpacing: "0.15px",

                    }}>Shortcuts</Typography>
                </Container>
                {isEditMode === false ?
                    <Tooltip title="Edit">
                        <IconButton color="primary" onClick={toggleEdit} aria-label='Edit'>
                            < EditIcon />
                        </IconButton>
                    </Tooltip>

                    :
                    <Button onClick={handleSaveChanges} size="small" sx={{
                        minWidth: "131px",
                        maxHeight: "30px",
                        paddingTop: "10px",
                        paddingBottom: "10px",
                        paddingLeft: "4px",
                        paddingRight: "4px"

                    }} aria-label="Save Changes" color="primary" variant="contained">
                        Save Changes
                    </Button>
                }

            </Container>

            <Container disableGutters sx={{
                display: "flex", flexDirection: "row", flexWrap: "wrap", height: "584px", width: "100%", padding: 1, gap: 1
            }}>
                {
                    state.shortcuts.map((shortcut) => (
                        <Shortcut
                            key={shortcut.id}
                            shortcut={shortcut}
                            label={shortcut.name}
                            description={shortcut.description}
                            isVisible={shortcut.isVisible}
                            dispatch={dispatch}
                            isEditMode={isEditMode}
                            toggleVisibility={() => handleToggleShortCutVisbility(shortcut.id)}
                            state={state}
                        >
                            <Link to={shortcut.link}>
                                {shortcut.icon}
                            </Link>
                        </Shortcut>
                    ))
                }
                <Button onClick={handleReset}>RESET CHANGES</Button>
            </Container>

        </>
    )
}

export default Shortcuts;